import userService from '../services/userService';

export function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export function pushSupported() {
    return 'serviceWorker' in navigator && 'PushManager' in window;
}

/**
 * iOS exposes Web Push only inside an installed PWA — in a plain Safari tab
 * there is no PushManager at all, which is indistinguishable from an old
 * unsupported browser unless we check for it.
 */
export function needsIosInstall() {
    const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent)
        // iPadOS 13+ reports itself as a Mac; touch points give it away.
        || (/Mac/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
    const isInstalled = window.matchMedia('(display-mode: standalone)').matches
        || navigator.standalone;
    return isIOS && !isInstalled;
}

export async function subscribeAndSave() {
    const publicKey = await userService.getPushPublicKey();
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
    await userService.subscribePush(subscription.toJSON());
}

// ponytail: heal on app open instead of a pushsubscriptionchange listener in the
// service worker. Push subscriptions rotate at the browser's discretion and the
// old one dies silently — the user thinks notifications are on and gets nothing.
// The SW cannot re-register on its own because the auth token lives in
// localStorage, which it can't read. Upgrade path, if users turn out to miss
// notifications between app opens: an unauthenticated endpoint that swaps the
// old subscription for the new one keyed by the old endpoint, so the SW can heal
// while the app is closed.
export async function syncPushSubscription() {
    try {
        if (!pushSupported() || Notification.permission !== 'granted') return;
        const registration = await navigator.serviceWorker.ready;
        if (await registration.pushManager.getSubscription()) return; // still alive
        await subscribeAndSave();
    } catch {
        // silent — this is background repair, not something to interrupt for
    }
}
